import { createSignal, type Signal } from "solid-js"
import { samePosition } from "../../lib/core/tile_position_xy/samePosition"
import type { TilePositionXY } from "../../lib/core/tile_position_xy/TilePositionXY.type"
import type { Nullable } from "../../typescript"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export const useTouchStartPositionSignal = createSharedCachedFactory((): Signal<Nullable<TilePositionXY>> => {
  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<Nullable<TilePositionXY>>(null, {
    equals: samePosition,
  })

  return signal
})


